import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./add-attachment.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./add-attachment.component.scss?ngResource";
import { ChangeDetectionStrategy, Component } from "@angular/core";
let AddAttachmentComponent = class AddAttachmentComponent {
    constructor() { }
    ngOnInit() {
    }
    static ctorParameters = () => [];
};
AddAttachmentComponent = __decorate([
    Component({
        standalone: false,
        selector: 'app-add-attachment',
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], AddAttachmentComponent);
export { AddAttachmentComponent };
